
import {Component, Vue} from "vue-property-decorator";
import {DateTime} from "luxon";
import {Pattern} from "@/addons/Pattern";
import {sancionStore} from "@/store/sancionStore";
import {SancionService} from "@/services/SancionService";
import SancionShow from "@/views/sanciones/SancionShow.vue";
import SancionNew from "@/views/sanciones/SancionNew.vue";
import {Alert} from "@/addons/Alert";
import SancionObservar from "@/views/sanciones/observar.vue";
import router from "@/router";
import {materialStore} from "@/store/materialStore";
import {MaterialService} from "@/services/MaterialService";
import {UserAuth} from "@/models/UserAuth";
import {globalStore} from "@/store/globalStore";

@Component({
  name: "MaaximosMinimosIndex",
  components: {SancionObservar, SancionNew, SancionShow},
})
export default class SancionIndex extends Vue {

  globalStore = globalStore();
  private patterns = Pattern;
  search = null
  private sancionStore = sancionStore();
  private materialStore = materialStore();

  private sancionService = SancionService.getInstance();
  private materialService = MaterialService.getInstance();
  private fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
  private fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");
  private sancionSeleccionada: any = null;

  private isObservar = false;

  grupo_id = "Todos";

  get grupoMaterial(): any {
    return this.materialStore.grupoMaterial;
  }

  get materiales(): any[] {
    return this.materialStore.materialesListado;
  }

  getGrupoMaterial() {
    this.materialService.getGrupoMaterial();
  }

  get loading(): boolean {
    return this.sancionStore.loading;
  }

  get pagination(): any {
    return this.materialStore.pagination;
  }

  get showDialogSancion(): boolean {
    return this.sancionStore.showDialogSancion;
  }

  get isNew(): boolean {
    return this.sancionStore.isNew;
  }

  mounted() {
    this.listar();
    this.getGrupoMaterial();
  }
  imprimirInventario(){
    this.materialService.imprimirInventario(this.grupo_id);
  }

  maximos(){

    const data = {
      user: this.usuario.email
    };
    this.materialService.maximos(data);
  }
  get usuario(): UserAuth {
    return this.globalStore.user;
  }

  imprimirInventarioDiario(id:number){
      this.sancionService.imprimirPlan(id);
  }
  listar() {
    const data = {
      fechaInicial: this.fechaInicial,
      fechaFinal: this.fechaFinal,
      search: this.search,
      grupo: this.grupo_id,
      page: this.pagination.current_page
    };
    this.materialService.index(data);
  }

  editar(material:any){
    router.push({name: 'materialEdit', params: {materialEdit: material}})
  }


  openSancion(sancion:any, isNew:boolean) {
    this.sancionSeleccionada = sancion;
    this.sancionStore.showDialogSancion = true;
    this.sancionStore.isNew = isNew;
    this.sancionService.showPlaPagoSancion(sancion);

    const data = {
      sancion: sancion,
      modelo: 'sancion',
    };
    this.sancionService.historial(data);
  }
  openSancionNew(sancion:any, isNew:boolean) {
    router.push({name: 'materialNew'});
  }


  eliminarMaterial(material:any) {
    Alert.confirm(`Eliminar el Material al: <br>
                    Cliente: ${material.descripcion}`
    ).then(res => {
      const data = {materialId: material.id}
      if (res.isConfirmed) {
        this.materialService.deleteMaterial(data);
        this.listar();
      }
    })
  }

  closeSancion() {
    this.sancionStore.showDialogSancion = false;
    this.sancionStore.sancion = []
    this.sancionStore.cliente = []
    this.sancionStore.isNew = false;
  }
}
